import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, BehaviorSubject, catchError, filter, switchMap, take, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { AdminCommonService } from '../../features/Admin/common/admin-common.service';
import { environment } from 'src/environments/environment';

let isRefreshing = false;
const REFRESH_FAILED = '__REFRESH_FAILED__';
const refreshTokenSubject = new BehaviorSubject<string | null>(null);
let token:any;
let authReq:any;
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const commonService = inject(CommonService)
  const adminCommonService = inject(AdminCommonService)
  const auth = inject(AuthService);
  const pmsToken = localStorage.getItem('pms_access_token');
  const authToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  const sessionMenuId: any = JSON.parse(sessionStorage.getItem('menuId') || JSON.stringify({ menuId: 0 }))?.menuId
  const MenuId = adminCommonService.getMenuId() || sessionMenuId
   
  if(req?.url.includes('user/updateudyampandetails')){
    authReq = req.clone({});
  }else{

     token = req.url.includes(environment.pmsBasePath) || req.url.includes('pms/saveregdetailstopms')
      ? pmsToken
      : authToken;
       authReq = req.clone({
        setHeaders: {
          MenuId: `${MenuId}`,
          Authorization: `Bearer ${token || ''}`,
        },
      });
  }


  return next(authReq).pipe(
    // tap((event: HttpEvent<any>) => {
    //   if (event instanceof HttpResponse) {
    //     const secretKey = "I5A6algZSxZXsQR3NOb5vdA8FLOnQIBf4QlxYg7Fsb0="
    //     const xSignature = event.headers.get('x-signature');
    //     if (xSignature) {
    //       const responseBody = event.body;
    //       const clientSignature = commonService.generateSignature(responseBody, secretKey);
    //       console.log("xSignature:",xSignature, "clientSignature:", clientSignature);
    //       if (xSignature === clientSignature) {
    //         console.log('✅ Response Verified');
    //       } else {
    //         console.warn('❌ Response has been tampered!');
    //       }
    //     }
    //   }
    // }),

    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error.status);
      }

      if (!refreshToken) {
        auth.authClearLocalAndSession();
        commonService.setRefreshHeaderMenu({ logout: true });
        return throwError(() => new Error('No refresh token available'));
      }

      if (!isRefreshing) {
        isRefreshing = true;
        refreshTokenSubject.next(null);

        return auth.refreshToken().pipe(
          catchError((refreshError: HttpErrorResponse) => {
            isRefreshing = false;
            refreshTokenSubject.next(REFRESH_FAILED);
            auth.authClearLocalAndSession();
            commonService.setRefreshHeaderMenu({ logout: true });
            return throwError(() => new Error('Authentication error or refresh token failed'));
          }),

          switchMap(() => {
            isRefreshing = false;
          
            const newToken = localStorage.getItem('access_token');
            refreshTokenSubject.next(newToken);
          
            const retryReq = req.clone({
              setHeaders: {
                MenuId: `${MenuId}`,
                Authorization: `Bearer ${newToken || ''}`,
              },
            });
            return next(retryReq).pipe(
              catchError((retryError: HttpErrorResponse) => {
                if (retryError.status === 401) {
                  auth.authClearLocalAndSession();
                  commonService.setRefreshHeaderMenu({ logout: true });
                }
                return throwError(() => retryError.status);
              })
            );
          })
        );

      } else {
        return refreshTokenSubject.pipe(
          filter(token => token !== null),
          take(1),
          switchMap((newToken) => {
            if (newToken === REFRESH_FAILED) {
              return throwError(() => new Error('Authentication error or refresh token failed'));
            }
            const retryReq = req.clone({
              setHeaders: {
                MenuId: `${MenuId}`,
                Authorization: `Bearer ${newToken || ''}`,
              },
            });
            return next(retryReq);
          })
        );
      }
    })
  );
};
